// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "电力电子技术",
      "tec": "肖艳辉",
      "week": "6,9-11,14-17周",
      "add": "实训楼F座201自控"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "Python程序设计",
      "tec": "肖艳辉",
      "week": "1-6,9-10周",
      "add": "实训楼F座213自实"
    },
    0,
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "电力电子技术",
      "tec": "肖艳辉",
      "week": "6,9-11,14-17周",
      "add": "实训楼F座201自控"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "Python程序设计",
      "tec": "肖艳辉",
      "week": "1-6,9-10周",
      "add": "实训楼F座213自实"
    },
    0,
    0,
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
